import React, { useState } from 'react'
import { Modal } from 'react-bootstrap'
import { Document, Page, pdfjs } from 'react-pdf'
import { MOBILE_THRESHOLD, SIZES } from 'src/styles/theme'
import { useWindowSize } from 'src/utils/useWindowSize'
import styled from 'styled-components'

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`

const SharedModal = styled(Modal)`
  &::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none;  /* IE and Edge */
  scrollbar-width: none;  /* Firefox */

  .modal-dialog {
    width: 100%;
    max-width: 100%;
    margin: 0 !important;
    border-radius: 0;
  }
  .modal-content {
    border-radius: 0;
    width: 100%;
    min-height: 100vh;
    max-width: 100%;
    background: rgba(0, 0, 0, 0.45);
  }
  .react-pdf__Page__canvas {
    width: 100%;
    max-width: 100vw !important;
  }
  .react-pdf__Page__textContent {
    display: none;
  }

  .modal-header {
    padding: 8px;
    border: none;
    display: block;
    background: rgba(0, 0, 0, 0.85);
    position: sticky;
    top: 0;
    z-index: 1000;
   
    button.close {
      opacity: 1;
      padding: 4px auto !important;
      z-index: 100;
      position: absolute;
      top: 5px;
      right: 5px;
      span {
        font-weight: 400;
        font-size: 34px;
        color: #f8c605;
        text-shadow: none;
      }
    }
  }
  p.file-description {
    padding: 8px auto;
    font-size: 16px;
    margin: 0;
    color: #f8c605;
    font-weight: 500;
    text-align: center;
  }
  .modal-body {
    padding: 0;
    width: 100%;
    display: flex;
    justify-content: center;
    max-width: 100%;
  }
  .buttons {
    position: absolute;
    top: 5px;
    left: 5px;
    display: flex;
    z-index: 1000;
  }
  ${SIZES.mobile} {
    .modal-header {
      display: flex;
      align-items: center;
      button.close {
        position: static;
        margin: 0;
        padding: 0;
      }
    }
    p.file-description {
      font-size: 14px;
      text-align: left;
    }
    .modal-content {
      background: rgba(0, 0, 0, 0.5);
    }
    .buttons {
      position: static;
    }
    .zoom-btn {
      margin: 0 2px;
      width: 30px;
      height: 30px;
    }
  }
`

export const DocumentViewer = ({ file, setDocumentSelected }) => {
  const { windowWidth } = useWindowSize()
  
  const [numPages, setNumPages] = useState(null)
  const [scale, setScale] = useState(1.0)

  const pdfWidth = windowWidth <= MOBILE_THRESHOLD ? windowWidth : 744

  const handleZoomIn = () => {
    if (scale < 1.4) {
      setScale(scale + 0.1)
    }
  }

  const handleZoomOut = () => {
    if (scale > 0.5) {
      setScale(scale - 0.1)
    }
  }
  const handleDownload = () => {
    window.open(file?.url, "_blank")
  }

  return (
    <SharedModal show={true} onHide={() => setDocumentSelected(null)} size="lg" aria-labelledby="gallery-pdf-modal" centered>
      <Modal.Header closeButton>
        <p className="file-description">{file?.filename}</p>
        <div>
          <div className='buttons noselect'>
            <div className='zoom-btn' onClick={handleDownload}>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#000" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <path stroke="#000" d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                <polyline stroke="#000" points="7 10 12 15 17 10"></polyline>
                <line stroke="#000" x1="12" y1="15" x2="12" y2="3"></line>
              </svg>
            </div>
            <div className='zoom-btn' onClick={handleZoomIn}>+</div>
            <div className='zoom-btn' onClick={handleZoomOut}>-</div>
          </div>
        </div>
      </Modal.Header>
      <Modal.Body>
        <div>
          <Document
            file={file?.url}
            loading={<p className="text-center text-white mt-3">Loading...</p>}
            onLoadSuccess={({ numPages }) => {
              setNumPages(numPages)
            }}
          >
            {Array.apply(null, Array(numPages))
              .map((x, i)=>i+1)
              .map(page =>  <Page pageNumber={page} scale={scale} width={pdfWidth} />)
            }
          </Document>
        </div>
      </Modal.Body>
    </SharedModal>
  )
}
